const VIEWS = {
    mobile: require('../modules/views/room_selection_manager.mobile'),
    desktop: require('../modules/views/room_selection_manager.desktop'),
};

Odigeo.defineWidget('room_selection_manager', Odigeo.Widget.extend({
    modelClass: require('../modules/models/room_selection_manager'),

    beforeConstructView() {
        this.viewClass = Odigeo.View.extend(VIEWS[this.options.viewClass]);
    },

    initRoomSelection(templates, preselectedRoom, resetRoomStatus) {
        if (resetRoomStatus) {
            this.view.resetCollapseConfig();
        }
        this.view.removeUnavailableRoomMessage();
        this.view.loadTemplates(templates);
        this.view.setSelectedRoom(preselectedRoom);
    },

    init() {
        this.opts = Odigeo.Utils.parseOptions(this.options);
    },

    update() {
        this.model.update.apply(this.model, arguments);
    },

    reset() {
        this.model.reset.apply(this.model, arguments);
    },

    refreshRoomSelection(data) {
        this.model.refreshRoomSelection(data);
    },

    getUnavailableRoomMessage() {
        this.view.getUnavailableRoomMessage();
    },

    abortRequest(abortStatusText) {
        this.model.abortRequest(abortStatusText);
    },

    setSelectedRoom(roomGroupKey) {
        this.view.setSelectedRoom(roomGroupKey);
    },

    setRoomContainer: function(container) {
        this.view.setElement(container);
    },
    render: function() {
        this.view.render();
    },
}));
